// eszköz-státusz badge — a jel a KÖZÖS badge-katalógusból jön (`domain-badge.tsx`, `assetStatus` fogalom):
// az igénylés-workflow (folyamatban lévő) állapotai a hideg/figyelmeztető paletta, a leltári (kész/aktív/
// kivezetett) a meleg/zöld/semleges paletta, mindegyik vezető ikonnal. ez a fájl csak a kényelmes, névre
// szóló API-t tartja meg.
import { DomainBadge } from '@/components/shared/domain-badge';

export interface AssetStatusBadgeProps {
  /** A nyers státusz-string (a jel forrása). */
  status: string;
  /** A megjelenített (lokalizált) címke — a hívó adja `t('assets.statusLabel.…')`-ből. */
  label: string;
  className?: string;
}

export function AssetStatusBadge({ status, label, className }: AssetStatusBadgeProps): JSX.Element {
  return <DomainBadge kind="assetStatus" value={status} label={label} className={className} />;
}
